<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">Blood Slide Location</h2>
      <p class="tw-italic tw-text-gray-700">
        View Inter-Station Blood Slide Transfer Form Data
      </p>
    </b-container>
    <br />

    <b-row>
      <b-col cols="3">
        <b-form-group
          id="fieldset-1"
          label="Bloodslide Code"
          label-for="input-1"
        >
          <b-input-group>
          <b-form-input id="input-1" v-model="search_keyword" trim v-on:keydown.enter="updateTable"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="updateTable"><i class="fa fa-search"></i></b-button>
          </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          id="fieldset-1"
          label="Study Phase"
          label-for="studyPhase"
        >
          <b-form-select id="studyPhase" v-model="filterPhase" :options="phaseOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          id="location1id"
          label="BS1 Location"
          label-for="readercodeoptions"
        ><b-form-select id="locationoptions" v-model="filterBS1Location" :options="locationOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          id="location2id"
          label="BS2 Location"
          label-for="readercodeoptions"
        ><b-form-select id="locationoptions" v-model="filterBS2Location" :options="locationOptions"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="3">
        <label for="bs1start_date">Bs1 Scan Start Date</label>
        <b-form-datepicker
          id="bs1start_date"
          v-model="bs1start_date"
          placeholder="Start Date"
          class="mb-2"
          reset-button
          :disabled='bs2start_date!=""'
        >
        </b-form-datepicker>
      </b-col>
      <b-col lg="3">
        <label for="bs1end_date">Bs1 Scan End Date</label>
        <b-form-datepicker
          id="bs1end_date"
          :min="bs1start_date"
          v-model="bs1end_date"
          placeholder="End Date"
          class="mb-2"
          reset-button
          :disabled='bs1start_date==""'
        >
        </b-form-datepicker>
      </b-col>
      <b-col lg="3">
        <label for="bs2start_date">Bs2 Scan Start Date</label>
        <b-form-datepicker
          id="bs2start_date"
          v-model="bs2start_date"
          placeholder="Start Date"
          class="mb-2"
          reset-button
          :disabled='bs1start_date!=""'
        >
        </b-form-datepicker>
      </b-col>
      <b-col lg="3">
        <label for="bs2end_date">Bs2 Scan End Date</label>
        <b-form-datepicker
          id="bs2end_date"
          :min="bs2start_date"
          v-model="bs2end_date"
          placeholder="End Date"
          class="mb-2"
          reset-button
          :disabled='bs2start_date==""'
        >
        </b-form-datepicker>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="3">
          <b-button @click="refreshFilters">Reset Filters</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <small>Total Results: {{ totalRows }} <i @click="downloadFile" class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download All"></i></small>
      </b-col>
    </b-row>

    <div style="width: 100%; overflow: auto;">
      <b-table
        striped
        hover
        :items="find"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="resultTable"
        @row-clicked="rowClick"
        :tbody-tr-class="'clickable'"
      >
      </b-table>
    </div>

    <b-row>
      <b-col cols="2">
        <b-form-group id="fieldset-2" label="Results Per Page" label-for="input-2">
          <b-form-select id="input-2" v-model="perPage" :options="perPageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col class="my-1" cols="9" style="padding-top: 30px;">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [
    // BaseTemplate,
    DashboardBaseTemplate,
  ],
  components: {},
  props: {},
  data: function() {
    return {
      sortBy: 'bloodslide_code',
      sortDesc: true,
      slides: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      title: "",
      search_keyword: null,
      filterBS1Location: 'All',
      filterBS2Location: 'All',
      bs1start_date: '',
      bs1end_date: '',
      bs2start_date: '',
      bs2end_date: '',
      perPageOptions: [
        10,
        15,
        20,
        25,
        50
      ],
      filterPhase: 'Cohort 2',
      phaseOptions: [
        'All',
        'Baseline',
        'Cohort 1',
        'Cohort 2'
      ], 
      locationOptions: [
        {value: 'All', text: 'All'},
        {value: 'alupe', text: 'Alupe'},
        {value: 'kisian', text: 'Kisian'},
        {value: 'in transit', text: 'In Transit'}
      ],
      selectedMicroscopy: {
        bloodslide_code: '',
        reviewed: ''
      },
      
    };
  },
  computed: {},
  watch: {
    filterStatus: function(){
      this.updateTable();
    },
    filterPhase: function(){
      this.updateTable();
    },
    filterBS1Location: function(){
      this.updateTable();
    },
    filterBS2Location: function(){
      this.updateTable();
    },
    bs1end_date: function(){
      this.updateTable();
    },
    bs2end_date: function(){
      this.updateTable();
    },
  },
  created: function() {
    this.setUpFields(this.$route.params.view);
  },
  mounted: function() {},
  methods: {
    downloadFile: function(){
      let that = this;
      let params = {}

      if(that.search_keyword && that.search_keyword != ''){
        params.search_keyword = that.search_keyword;
      }
      if(that.filterPhase != 'All'){
        params.study_phase = that.filterPhase;
      }
      if(that.filterBS1Location != 'All'){
        params.bs1_location = that.filterBS1Location;
      }
      if(that.filterBS2Location != 'All'){
        params.bs2_location = that.filterBS2Location;
      }
      if(that.bs1start_date != '' && that.bs1end_date != ''){
        params.bs1start_date = that.bs1start_date;
        params.bs1end_date = that.bs1end_date;
      }
      if(that.bs2start_date != '' && that.bs2end_date != ''){
        params.bs2start_date = that.bs2start_date;
        params.bs2end_date = that.bs2end_date;
      }

      params.return_as = 'csv';
      // switched to using the same endpoint as the one that feeds the table:
      // HTTP.get('/kenya/blood_slide_location_download').then(response => {
      return HTTP.get("/kenya/blood_slide_location", {
        params: params
      }).then(response => {
          var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          // const today = new Date();
          // fileLink.setAttribute("download", "BloodSlideLocations-" + today + ".csv");
          fileLink.setAttribute("download", "BloodSlideLocations.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    updateTable: function(){
      this.$refs.resultTable.refresh();
    },
    refreshFilters: function(){
      let that = this;
      that.bs1start_date = '';
      that.bs1end_date = '';
      that.bs2start_date = '';
      that.bs2end_date = '';
      that.filterBS1Location = 'All';
      that.filterBS2Location = 'All';
      that.filterPhase = 'Cohort 2';
      that.search_keyword = null;
    },
    printTable: function(){
      let table_id = this.$refs.resultTable.localId_;
      var divToPrint=document.getElementById(table_id);
      var newWin = window.open("");
      var html_to_print = divToPrint.outerHTML.replaceAll(' (Click to clear sorting)', '').replaceAll(' (Click to sort Ascending)', '');
      var all_html = '<html><head>\
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" integrity="undefined" crossorigin="anonymous">\
      <body>\
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" integrity="undefined" crossorigin="anonymous">\
      '+html_to_print+'<style>\
      </style>\
      </body></html>';
      // get the stylesheet
      newWin.document.write(all_html);
      newWin.document.close();
      var myDelay = setInterval(checkReadyState, 10);
      function checkReadyState() {
          if (newWin.document.readyState == "complete") {
              clearInterval(myDelay);
              newWin.focus(); // necessary for IE >= 10

              newWin.print();
              newWin.close();
          }
      }
    },
    rowClick: function(item){
      let that = this;
      that.selectedMicroscopy = item;
      console.log(item);
    },
    find: function(ctx) {
      let that = this;
      let params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
        sort_by: ctx.sortBy,
        sort_desc: ctx.sortDesc
      }

      if(that.search_keyword && that.search_keyword != ''){
        params.search_keyword = that.search_keyword;
      }
      if(that.filterPhase != 'All'){
        params.study_phase = that.filterPhase;
      }
      if(that.filterBS1Location != 'All'){
        params.bs1_location = that.filterBS1Location;
      }
      if(that.filterBS2Location != 'All'){
        params.bs2_location = that.filterBS2Location;
      }
      if(that.bs1start_date != '' && that.bs1end_date != ''){
        params.bs1start_date = that.bs1start_date;
        params.bs1end_date = that.bs1end_date;
      }
      if(that.bs2start_date != '' && that.bs2end_date != ''){
        params.bs2start_date = that.bs2start_date;
        params.bs2end_date = that.bs2end_date;
      }

      return HTTP.get("/kenya/blood_slide_location", {
        params: params
      })
        .then((response) => {
          that.slides = response.data.slides;
          that.totalRows = response.data.totalRows;
          return that.slides;
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    setUpFields: function(view) {
      if (view == "details") {
        this.title = "Details";
        this.fields = [
        //   { key: "bloodslide_code", label: "Bloodslide Code" },
        ];
      } else {
        this.title = "Summary";
        this.fields = [
        //   { key: "bloodslide_code", label: "Bloodslide Code", sortable: true },
        ];
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.setUpFields(to.params.view);
    next();
  }
};
</script>

<style scoped>
.clickable{
  cursor: pointer;
}
</style>
